import { useEffect } from "react";
import Frame from "./frame";
import { Box, Button, InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { CustomTextField } from "../../components/TextFields";
import PassWordInput from "../../components/inputs/passwordInput";
import { HalfWidthButton } from "../../components/Button";
import TextContainer from "../../components/Texts/TextContainer";
import PersonIcon from "@mui/icons-material/Person";
import { Helmet } from "react-helmet";
import { useLoginMutation } from "../../app/services/auth.api";
const schema = yup.object().shape({
  phone: yup.string().required("شماره همراه الزامی است."),
  password: yup.string().required("رمز عبور الزامی است."),
});

export default function Login() {
  const {
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const navigate = useNavigate();
  const [login] = useLoginMutation();
  const handleLogin = () =>
    handleSubmit(
      (data) => {
        login(data)
          .unwrap()
          .then(() => navigate("/"))
          .catch((err) => {});
      },
      (err) => console.error(err)
    )();
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Frame text="پنل مدیریت">
      <Helmet>
        <title> ورود | پنل ادمین yaadin</title>
      </Helmet>
      <Box>
        <CustomTextField
          label="شماره همراه"
          onChange={(e) => setValue("phone", e.target.value)}
          error={!!errors.phone}
          helperText={errors.phone?.message}
          required
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <PersonIcon sx={{ color: "divider", padding: "5px" }} />
              </InputAdornment>
            ),
          }}
        />
        <PassWordInput
          label="رمز عبور"
          required
          onChange={(e) => setValue("password", e.target.value)}
          error={!!errors.password}
          helperText={errors.password?.message}
        />
      </Box>
      <Button sx={[{ boxShadow: [2] }, HalfWidthButton]} onClick={handleLogin}>
        ورود
      </Button>
      <TextContainer
        color="divider"
        fontSize="1rem"
        width="100%"
        justifyContent="center"
        textAlign="center"
      >
        این وبسایت از کوکی برای تجربه بهتر کاربری استفاده میکند. با ورود به
        سیستم شما این مورد را پذیرفته اید
      </TextContainer>
    </Frame>
  );
}
